export default "__VITE_ASSET__d44ed837__"